"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _log = _interopRequireDefault(require("@gasket/log"));
var _getEnvironment = require("../helpers/getEnvironment");
/**
 * Temporary logger for useSubmitDifyLead hook using @gasket/log since apm is not avail for loader
 */

var env = (0, _getEnvironment.getEnvironment)();
var isProd = env === _getEnvironment.Env.PROD;
var isLocal = env === _getEnvironment.Env.LOCAL;
var logger = new _log.default({
  prefix: 'useSubmitDifyLead',
  prod: isProd,
  local: isLocal
});
var _default = exports.default = logger;